<template>
  <div>
    <el-form :model="form" :rules="rules" ref="form" label-width="250px">
      <el-form-item
        label="Select Customer"
        prop="customerId"
        :rules="[
          { required: true, message: 'Please select customer', trigger: 'blur' },
        ]"
      >
        <el-select v-model="form.customerId" :loading="loading">
          <el-option
            v-for="customer in customers"
            :key="customer._id"
            :label="customer.company"
            :value="customer._id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="Desired move in date"
        prop="desiredDate"
        :rules="[
          { required: true, message: 'Please input Desired Date', trigger: 'blur' },
        ]"
      >
        <el-date-picker
          v-model="form.desiredDate"
          type="date"
          :picker-options="datePickerOptions"
          placeholder="Move In Date">
        </el-date-picker>
      </el-form-item>
      <el-form-item
        label="Size Requirement Note"
        prop="sizeNote"
      >
        <el-input v-model="form.sizeNote">
        </el-input>
      </el-form-item>
      <el-form-item
        label="Min Size Requirement in Sq ft."
        prop="minSize"
      >
        <el-input-number v-model="form.minSize" :step="10" :min="10">
        </el-input-number>
      </el-form-item>
      <el-form-item
        label="Max Size Requirement in Sq ft."
        prop="maxSize"
      >
        <transition name="el-fade-in">
          <el-input-number v-show="showMax" v-model="form.maxSize" :step="10">
          </el-input-number>
        </transition>
        <el-tooltip class="item" effect="dark" content="Add size as a range?" placement="top-start">
          <el-button type="text" v-show="!showMax" @click="() => showMax = true">
            Set Size Max Value?
          </el-button>
        </el-tooltip>
        <el-tooltip
          class="item"
          content="Remove Max size, enable no validation for max size."
          placement="top-start"
        >
          <el-button type="text" v-show="showMax" @click="removeMax">Remove Max</el-button>
        </el-tooltip>
      </el-form-item>
      <el-form-item
        label="Note"
      >
        <el-input
          type="textarea"
          v-model="form.note"
        >
        </el-input>
      </el-form-item>
      <el-button
        @click="saveWaitList"
        :loading="buttonLoading"
        type="primary"
        round
      >
        Save
      </el-button>
    </el-form>
  </div>
</template>

<script>
import axios from 'axios';
import { CUSTOMER_API_BASE } from '../env';

export default {
  name: 'CustomerWaitList',
  props: {
    facility: { type: String, required: true },
  },
  data() {
    const checkMaxSize = (rule, value, callback) => {
      if (!this.showMax) {
        return callback();
      }
      if (value && value < this.form.minSize) {
        return callback(new Error('Max size should be greater than min size value'));
      }
      callback();
    };
    const checkMinSize = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('Please input the min size'));
      }
      if (value && this.form.maxSize && value > this.form.maxSize) {
        return callback(new Error('Min size should be less than max size value'));
      }
      callback();
    };
    return {
      loading: true,
      buttonLoading: false,
      customers: [],
      showMax: false,
      form: {
        customerId: null,
        sizeNote: '',
        size: 100,
        maxSize: null,
        minSize: 10,
        desiredDate: null,
        note: '',
      },
      rules: {
        maxSize: {
          validator: checkMaxSize, trigger: 'blur',
        },
        minSize: {
          validator: checkMinSize, trigger: 'blur',
        },
      },
      datePickerOptions: {
        disabledDate(date) {
          return date < new Date();
        },
      },
    };
  },
  watch: {
    async facility() {
      await this.getCustomers();
    },
  },
  async mounted() {
    await this.getCustomers();
  },
  methods: {
    removeMax() {
      this.showMax = false;
      this.form.maxSize = null;
    },
    async getCustomers() {
      try {
        const response = await axios.get(`${CUSTOMER_API_BASE}/customers/v1/get/all`, {
          params: {
            limit: 250,
          },
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        });
        // eslint-disable-next-line no-console
        this.customers = response.data;
        this.loading = false;
      } catch (err) {
        this.loading = false;
        this.$notify.error({
          title: 'Error',
          message: err.response.data,
        });
      }
    },
    async saveWaitList() {
      this.buttonLoading = true;
      this.$refs.form.validate(async (valid) => {
        if (!valid) {
          this.buttonLoading = false;
          return;
        }
        try {
          await axios.post(`${CUSTOMER_API_BASE}/customers/v1/customer/wait/list`, {
            ...this.form,
            facility: this.facility,
            createdBy: this.$keycloak.tokenParsed.email,
            createdAt: new Date(),
          }, {
            headers: {
              Authorization: `Bearer ${this.$keycloak.token}`,
            },
          });
          this.buttonLoading = false;
          this.form = {
            customerId: null,
            sizeNote: '',
            size: 100,
            minSize: 0,
            maxSize: null,
            desiredDate: null,
            note: '',
          };
          this.$emit('close');
          this.$notify.success({
            title: 'Success',
            message: 'Customer waitlist added successfully.',
          });
        } catch (err) {
          this.buttonLoading = false;
          this.form = {
            customerId: null,
            sizeNote: '',
            size: 100,
            desiredDate: null,
            note: '',
          };
          this.$notify.error({
            title: 'Error',
            message: err.response.data,
          });
        }
      });
      this.buttonLoading = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/CustomerWaitList.vue